export default __webpack_public_path__ + "images/zoom.2d64140.svg";